import * as uiActions from '../actions/ui.action';


export interface State {
    loading: boolean;
    loaded: boolean;
    error: any;
}


export const initialState: State = {
    loading: false,
    loaded: false,
    error: null
};



export function reducer(state = initialState, action: uiActions.uiActions) {
    switch (action.type) {
        case uiActions.PAGE_LOADING: {
            return {
                loading: true,
                loaded: false,
                error: null
            };
        }
        case uiActions.PAGE_LOADED: {
            return {
                loading: false,
                loaded: true,
                error: null
            };
        }
        case uiActions.SHOW_ERROR: {
            return {
                loading: false,
                loaded: false,
                error: action.payload
            };
        }
        default:
        return state;
    }
}




// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/store/reducers/ui.reducer.ts